import { get, post } from "./api-client";

export const blogService = {
    getBlogList: (data) => post('/blog/list', data),

    getBlogById: (blogpostId) => get(`/blog/getBlogPost/${blogpostId}`)
};